import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {Table} from 'react-bootstrap';
import swal from 'sweetalert';
import Moment from 'react-moment';
import WaitingModal from '../generics/WaitingModal';
import ModalPhenotype from '../results_donation/components/ModalPhenotype';
import ModalUpdateRh from '../results_donation/components/ModalUpdateRh';
import Help from '../generics/help';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../generics/modal_person_search';

const {htmlToText} = require('html-to-text');
var Config = require('../../config');

class DonorSearch extends Component{
	constructor(props){
		super(props);
		this.updateStateDonor = this.updateStateDonor.bind(this);
		this.getDataDonation = this.getDataDonation.bind(this);
		this.person_search = this.person_search.bind(this);
		this.getInfo = this.getInfo.bind(this);
		
		this.state = { 
	    	dataSource:[],
	    	searchText: '',
	    	isLoading: false,
	    	optionsDonor:[],
	    	don_usr_clc:"",//criterio funcional cambiar lugar de colecta
	    	donorData:[],
	    	columns:[],
	    }
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=MODIFY_GROUP_PHEN',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
			console.log(response);
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	_handleSearchDonor = (query) => {
	    this.setState({isLoading: true});
		fetch(Config.default.apiGateway.URL+'donors?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					
					/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null  && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '+response[i].names +' '+ response[i].birthday;;
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ response[i].birthday;;
					}


					if(response[i].document !== null){							
						response[i].names +=' '+response[i].document_type_value;
						response[i].names +=' '+response[i].document_number;
						
					}
					response[i].id = response[i].donor_id;
				};
				
				this.setState({
					isLoading: false,
			      	optionsDonor: response
			    });
			}
		})
	}

	updateStateDonor(values) {
	    let value = '';
	    if (values.length > 0) {
	      value = values[0];
	    }
	    /*this.props.autocompleteHandle('blockFields',true);
	    this.props.autocompleteHandle('checkEditData',true);*/
	    
	    //this.props.getInfo(value.id);
	    this.getInfo(value.id);
	}

	//traer datos del donante
	getInfo(id){
		console.log(id)
		fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var temp = [];
			temp.push(response);
			console.log(temp)
			this.setState({
				donorData: temp
			});

			if(response.alerts !== undefined){
				if(response.alerts.length > 0){
					var alerts = "";
					response.alerts.map((n)=>{
						var note = htmlToText(n);

						alerts += note+'\n';
					})

					swal('Alerta', alerts, 'warning')
				
				}

				this.props.waiting.handleClose();
			} 
		})	
	}

	ageCalculate(fecha){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha);
	    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
	    var m = hoy.getMonth() - cumpleanos.getMonth();

	    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
	        edad--;
	    }

	    return edad;
	}

	getDataDonation(opt){

	}

	openModalGrupoRH(e,item){
		this.modal_update_rh.handleShow(item.person.id);
	}

	openModalPhenotype(e, item){
		e.preventDefault();
		this.modal_phenotype.handleShow(item.donor.id, item.person.id, 0, 'phenotypes');
	}

	person_search(){
		this.modal_person_search.handleShow('Donador','donors');
	}

	render(){
		const {t} = this.props;

		return (<div className="col-xs-12">
			<div className="route">
				<h5 className="title_page" >
				    {sessionStorage.getItem('health_facilities_name')} ->
					Inicio ->
					Laboratorio -> 
					Modificar Grupo y Fenotipo
				</h5>
			</div>
			
			<Help 
				{...this.props}
              	menu={"help_laboratory"} 
              	submenu={"help_change_group_phen"}  />
			<div className="col-xs-12 form-group">
				<div style={{padding:"0px"}}>
			        <div className="col-xs-8">
			 			<span className="span-min">{t('content.generics.buttons.search')}</span>
				        <AsyncTypeahead
				          /*{...this.state}*/
				          labelKey={(option) => `${option.names}`}
				          minLength={3}
				          maxLength={50}
				          name="patient"
				          id="patient"
				          onSearch={this._handleSearchDonor}
				          placeholder="Buscar por apellidos más nombre o número de documento..."
				          options={this.state.optionsDonor}
				          onChange={this.updateStateDonor}
				          ref="_handleSearchDonor"
				          useCache={false}
				          isLoading={this.state.isLoading}
				          delay={600}
				          paginationText="Mostrar mas resultados..."
				        />
				 			
					</div>

					<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
						<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
							onClick={this.person_search}/>
					</div>

			    </div>
			</div>
			<div className="col-xs-12">
		        <Table responsive hover>
    				<thead>
	                  	<tr>
		                    <th hidden={this.showColumn('NAME')}>Nombre</th>
		                    <th hidden={this.showColumn('BIRTHDAY')}>F. Nacimiento</th>
		                    <th hidden={this.showColumn('AGE')}>Edad</th>
		                    <th hidden={this.showColumn('SEX')}>Sexo</th>
		                    <th hidden={this.showColumn('GROUP_RH')}>Grupo Y RH</th>
		                    <th hidden={this.showColumn('CONTROLS')}></th>
	                  	</tr>
	                </thead>
	                <tbody>
	                 	{this.state.donorData.map( (item, index) => (
	                    	<tr key={index}>
	                      		<td hidden={this.showColumn('NAME')}>
	                      			{item.person.lastname1 +' '+ 
	                      			(item.person.lastname2 !== null ? item.person.lastname2 : '')+' '+
	                      			item.person.names}
	                      		</td>
		                      	<td hidden={this.showColumn('BIRTHDAY')}><Moment format="DD/MM/YYYY">{item.person.birthday}</Moment> 
		                      	</td>
		                      	<td hidden={this.showColumn('AGE')}>{this.ageCalculate(item.person.birthday)}</td>
		                      	<td hidden={this.showColumn('SEX')}>{item.person.sex} </td>
		                      	<td hidden={this.showColumn('GROUP_RH')}>{item.person.lookup_group} {item.person.lookup_rh === "POSITIVO"?"+":item.person.lookup_rh === "NEGATIVO"?"-":""}</td>
		                      	<td hidden={this.showColumn('CONTROLS')}>
		                      		<button type="button" className="btn btn-results" style={{margin:"5px 5px 5px 5px"}}
										onClick={(e) => this.openModalPhenotype(e, item)}>
										{t('content.generics.buttons.phenotypes')}
									</button>
									<button className="btn btn-results" type="button" style={{margin:"5px 5px 5px 5px"}} onClick={(e) => this.openModalGrupoRH(e, item)}>
										Grupo & RH 
									</button>
		                      	</td>
	                    	</tr>
	                  	))}
	                </tbody>
    			</Table>			
		    </div>
			{/*Modals*/}
			<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			<ModalUpdateRh {...this.props} 
				onRef={ref => (this.modal_update_rh = ref)} 
				getData={this.getDataDonation} 
				donor={this.state.donorData}
				getInfo={this.getInfo}
			/>
			<ModalPhenotype getFenotipoDonacion={this.getDataDonation} {...this.props} onRef={ref => (this.modal_phenotype = ref)} />
			<ModalPersonSearch {...this.props} waiting={this.props.waiting} 
				updatePerson={this.updateStateDonor} onRef={ref => (this.modal_person_search = ref)} />
		</div>)
	
	}
}

export default translate('translations') (DonorSearch);